/* src/app/workshop-defects/pages/workshop-defects/workshop-defects.component.scss */
/*# sourceMappingURL=workshop-defects.component.css.map */
